/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    user_type?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType;
    /**
     * 
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'title': json['title'] == null ? undefined : json['title'],
        'user_type': json['user_type'] == null ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSON(json['user_type']),
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'title': value['title'],
        'user_type': HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeToJSON(value['user_type']),
        'photo_url': value['photo_url'],
    };
}

